import { addErrorsAction } from "../../../actions/errors";
import * as actionTypes from "../../../constants";
import { parseServiceErrors } from "../../../services/encounter/serviceErrors";
import { groupingUtilsAPI } from "../../../services/grouping/utils";

import type { AnyAction } from "redux";
import type { ThunkAction } from "redux-thunk";
import type { IdDescriptionBase } from "../../../models/patientEncounter";
import type { State } from "../../../reducers";

/*
  Load additional lists for the encounter:
    - revenue codes
    - status indicators
*/

export const fetchRevenueCodes =
  (): ThunkAction<Promise<IdDescriptionBase[]>, State, unknown, AnyAction> => async (dispatch) => {
    dispatch(getRevenueCodesBegin());

    try {
      const result = await groupingUtilsAPI.getRevenueCodes();
      dispatch(getRevenueCodesCompleted(result));
      return result;
    } catch (reason) {
      const error = reason as Error;
      dispatch(getRevenueCodesError(error));

      const errors = parseServiceErrors(error, "Cannot Load Revenue Codes");
      dispatch(addErrorsAction(errors));
      return [];
    }
  };

export const getEncounterAdditionalLists =
  (): ThunkAction<Promise<void>, State, unknown, AnyAction> => async (dispatch) => {
    try {
      await dispatch(fetchRevenueCodes());
      await dispatch(fetchStatusIndicators());
    } catch (error) {
      // Errors are already handled inside fetchRevenueCodes and fetchStatusIndicators
    }
  };

export const fetchStatusIndicators =
  (): ThunkAction<Promise<IdDescriptionBase[]>, State, unknown, AnyAction> => async (dispatch) => {
    dispatch(getStatusIndicatorsBegin());

    try {
      const result = await groupingUtilsAPI.getStatusIndicators();
      dispatch(getStatusIndicatorsCompleted(result));
      return result;
    } catch (reason) {
      const error = reason as Error;
      dispatch(getStatusIndicatorsError(error));

      const errors = parseServiceErrors(error, "Cannot Load Status Indicators");
      dispatch(addErrorsAction(errors));
      return [];
    }
  };

const getRevenueCodesBegin = () => ({
  payload: "",
  type: actionTypes.REVENUE_CODES_GET_BEGIN,
});

const getRevenueCodesCompleted = (revenueCodes: IdDescriptionBase[]) => ({
  payload: revenueCodes,
  type: actionTypes.REVENUE_CODES_GET_COMPLETED,
});

const getRevenueCodesError = (error: Error) => ({
  payload: error,
  type: actionTypes.REVENUE_CODES_GET_ERROR,
});

const getStatusIndicatorsBegin = () => ({
  payload: "",
  type: actionTypes.STATUS_INDICATORS_GET_BEGIN,
});

const getStatusIndicatorsCompleted = (statusIndicators: IdDescriptionBase[]) => ({
  payload: statusIndicators,
  type: actionTypes.STATUS_INDICATORS_GET_COMPLETED,
});

const getStatusIndicatorsError = (error: Error) => ({
  payload: error,
  type: actionTypes.STATUS_INDICATORS_GET_ERROR,
});
